import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Problem } from './components/Problem';
import { PackageContents } from './components/PackageContents';
import { MapGallery } from './components/MapGallery';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0" data-mp="2mmvlkvs92ic2">
      <main data-id="element-1" data-mp="2mjpvpebsrcfa">
        <Hero data-id="element-2" data-mp="2mjzmv58kvpmk" />
        <Stats data-id="element-3" data-mp="31agoaol7qfjg" />
        <Problem data-id="element-4" data-mp="31ayr642drs0c" />
        <PackageContents data-id="element-5" data-mp="31bibtsjf0ui2" />
        <MapGallery data-id="element-6" data-mp="31ctefp14jw7l" />
        <Bonuses data-id="element-7" data-mp="2wk09b01quluz" />
        <Pricing data-id="element-8" data-mp="2wjgrrkg09zhh" />
        <Guarantee data-id="element-9" data-mp="2wiyxgtcwlvc7" />
        <Faq data-id="element-10" data-mp="2wifgpfyzpczr" />
      </main>
      <Footer data-id="element-11" data-mp="2wi5nljineppu" />
    </div>;
}